// Leaving a round with people (the leave rules). Each round left after it started, in a park with
// other people or at a stake table, gives the player a leave mark. Marks inside a rolling window
// set a wait before they may join or open another park with people: the first is a warning only,
// then the waits grow. Each round with people they finish takes one mark away. Solo is never held.
// The api enforces the wait, the persist worker writes and forgives marks, the phone only says it.
import { z } from 'zod';
export const leaveRulesSchema = z.strictObject({
    /** A mark older than this no longer counts. */
    windowMs: z
        .number()
        .int()
        .min(60_000)
        .max(7 * 86_400_000),
    /**
     * The wait after the newest mark, by how many marks count: [first, second, ...]. The last one
     * holds for every mark past it. 0 is a warning only.
     */
    waitsMs: z.array(z.number().int().min(0).max(86_400_000)).min(1).max(10),
    /** Marks one finished round with people takes away. */
    forgivenPerRound: z.number().int().min(0).max(10),
});
export const LEAVE_RULES = {
    windowMs: 24 * 3_600_000,
    waitsMs: [0, 2 * 60_000, 5 * 60_000, 15 * 60_000],
    forgivenPerRound: 1,
};
/** The wait a player with this many marks serves after the newest one (0: none, or a warning). */
export function leaveWaitMs(marks, rules = LEAVE_RULES) {
    if (marks <= 0)
        return 0;
    return rules.waitsMs[Math.min(marks, rules.waitsMs.length) - 1] ?? 0;
}
/** From the times of a player's unforgiven marks (any order) at `now`. */
export function leaveStanding(marksAt, now, rules = LEAVE_RULES) {
    const live = marksAt.filter((at) => at > now - rules.windowMs && at <= now);
    const newest = live.length ? Math.max(...live) : null;
    const wait = leaveWaitMs(live.length, rules);
    const until = newest !== null && wait > 0 && newest + wait > now ? newest + wait : null;
    return {
        marks: live.length,
        waitMs: until === null ? 0 : until - now,
        until,
        nextWaitMs: leaveWaitMs(live.length + 1, rules),
    };
}
//# sourceMappingURL=leave.js.map